export class DeleteErrorEffect {
  public static readonly type = '[Project/Storage/List] DeleteErrorEffect';
  constructor(public readonly error: Error) {}
}
